import LocationShipmentSummary from "../components/app/Shipment/LocationShipmentSummary";

function ShipmentSummaryPage(){
  return(
  <LocationShipmentSummary></LocationShipmentSummary>
  );
}

export default ShipmentSummaryPage